import type { QueryResult } from '@apollo/client';
import { Loader } from '@rulebooks/evidend-titan';
import { t } from '@lingui/macro';
import type { MutationQuery, MutationQueryVariables } from 'generated/gql';
import { useMutationQuery, type RegisterMutation } from 'generated/gql';
import { useGlobalError } from 'hooks/useGlobalError';
import { useRouter } from 'next/router';
import { createTypedContextProvider } from 'providers/createTypedContextProvider';
import React from 'react';

export interface MutationProviderProps {
  children: React.ReactNode;
}

export type SuccessfullMutationQueryResult = [
  RegisterMutation,
  Omit<QueryResult<MutationQuery, MutationQueryVariables>, 'data'> & {
    data: { mutation: RegisterMutation };
  },
];
export const [useMutationQueryProvider, MutationQueryContextProvider] =
  createTypedContextProvider<SuccessfullMutationQueryResult>();

export const MutationQueryProvider = ({ children }: MutationProviderProps) => {
  const router = useRouter();
  const [, setGlobalError] = useGlobalError();
  const mutationId = router.query.mutationId as string;
  const result = useMutationQuery({
    variables: {
      mutationId,
    },
    onError: (error) => {
      // Redirect to front page.
      console.warn(error);
      router.push('/');
      // Show specific error message.
      setGlobalError(t`De door jou opgevraagde workflow is niet meer beschikbaar.`);
    },
  });

  const mutation = result.data?.mutation;

  if (!mutation) return <Loader height={80} variant="spinner" />;
  return (
    <MutationQueryContextProvider
      value={[mutation as RegisterMutation, result as SuccessfullMutationQueryResult[1]]}
    >
      {children}
    </MutationQueryContextProvider>
  );
};
